import { styled } from "@linaria/react";
export const UriOverlayEditorStyle = /*#__PURE__*/styled('div')({
  name: "UriOverlayEditorStyle",
  class: "gdg-u1rrojo",
  propsAsIs: false
});

